/**
 * @fileoverview wsdot-bridge-clearances API - Core fetch functions and types only
 *
 * This module provides exports for fetch functions and types only (no React hooks).
 * Use this for backend/server-side code to avoid React Query dependencies.
 */

export * from "./bridgeClearances/bridgeClearances";
export * from "./bridgeClearances/bridgeClearancesByRoute";
export * from "./bridgeClearances/shared/bridgeClearances.input";
export * from "./bridgeClearances/shared/bridgeClearances.output";
